<template>
  <button class="btn btn-lg btn-primary" :id="id">
    <i :class="icon"></i> {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    text: {
      type: String
    }
  }
};
</script>
